<template>
	<div class="modal-delete-tag-container flex-col items-center">
		<h5
			class="modal-delete-tag-title text-white font-uppercase"
		>
			{{ $tc('modals.deleteUserTagModal.title') }}
		</h5>
		<h6 class="modal-delete-tag-body text-white text-center">
			{{ $tc('modals.deleteUserTagModal.mainText') }}
		</h6>
		<div class="modal-delete-tag-buttons flex">
			<button class="button-light-blue font-regular font-uppercase text-black mr-5 flex-center" @click="onClose">
				{{ $tc('modals.DeleteTagConfirm.cancelButtonText') }}
			</button>
			<button class="button-delete font-regular font-uppercase text-black ml-5 flex-center" @click="onConfirm">
				{{ $tc('modals.deleteUserTagModal.untagButtonText') }}
			</button>
		</div>
	</div>
</template>

<script>
import { ModalMixin } from '~/assets/vue/mixins'

export default {
	name: 'ModalDeleteUserTagConfirm',
	mixins: [ModalMixin],
	props: {
		options: {
			type: Object,
			required: true
		}
	}
}
</script>

<style lang="scss">

</style>
